import { dateFormatter, integerFormatter, numberFormatter } from "../../gridFormatters";

export const clusterModeling = [
	{
		"field": "collection_date",
		"headerName": "Date",
		"cellRenderer": dateFormatter,
	},
	{ headerName: 'Virtual CPU Used', field: 'total_virtual_cpus_used', "type": "numericColumn", "cellRenderer": numberFormatter, },
	{ headerName: 'Virtual CPU Capacity', field: 'cpu_size', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Virtual CPUs Allocated', field: 'total_virtual_cpus_alloc', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Memory Used (GiB)', field: 'memory_used', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Memory Capacity (GiB)', field: 'total_memory', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Disk Used (GiB)', field: 'used', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Disk Allocated (GiB)', field: 'allocated', "type": "numericColumn", "cellRenderer": integerFormatter },
	{ headerName: '# of VMs', field: 'num_vms', "type": "numericColumn", },
	{ headerName: 'VM Build Capacity', field: 'vm_build_capacity', "type": "numericColumn", },
]

export const clusterHostUsageHistory = [
	{
		"field": "collection_date",
		"headerName": "Date",
		"cellRenderer": dateFormatter,
	},
	{
		"field": "esx_host_name",
		"headerName": "ESX Host",
	},
	{ headerName: 'CPU Util', field: 'avg_cpu_util', "type": "numericColumn", },
	{ headerName: 'CPU Used (GHz)', field: 'avg_ghz_per_cpu', "type": "numericColumn", "cellRenderer": numberFormatter,},
	{ headerName: 'CPU Total (MHz)', field: 'total_mhz', "type": "numericColumn", "cellRenderer": integerFormatter },
	{ headerName: 'Memory Util', field: 'avg_memory_util', "type": "numericColumn", },
	{ headerName: 'Memory Total (GiB)', field: 'total_memory', "type": "numericColumn", "cellRenderer": integerFormatter },
	{ headerName: 'Disk Util', field: 'avg_disk_util', "type": "numericColumn", },
	{ headerName: 'Disk Used (GiB)', field: 'total_disk_used', "type": "numericColumn", "cellRenderer": integerFormatter },
	{ headerName: 'Disk Allocated (GiB)', field: 'total_disk_allocated', "type": "numericColumn", "cellRenderer": numberFormatter },
];
